import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <small class="created-by text-muted"><b><a href="" target="_blank" class="text-warning"> At3 Internet ©</a></b> 2019</small>
  `,
})
export class FooterComponent {
}



// WEBPACK FOOTER //
// /var/www/minha-at3-cliente/src/app/@theme/components/footer/footer.component.ts